const sampledata = [
    {
        key: '1',
        receipt_no: '10001210',
        invoice_date: '2022-06-08',
        invoice_no: '1000000111',
        customer: 'Mango Brothers',
        status: 'Posted'    
    },
    {
        key: '2',
        receipt_no: '10001211',
        invoice_date: '2022-06-08',
        invoice_no: '1000000112',
        customer: 'Chicken Salad Masters',
        status: 'Posted'    
    },
    {
        key: '3',
        receipt_no: '10001212',
        invoice_date: '2022-06-08',
        invoice_no: '1000000113',
        customer: 'Himalayo',
        status: 'Posted'    
    },
    {
        key: '4',
        receipt_no: '10001213',
        invoice_date: '2022-06-08',
        invoice_no: '1000000111',
        customer: 'Wag kang mainis mahal ang patis',
        status: 'Posted'    
    },
    {
        key: '5',
        receipt_no: '10001214',
        invoice_date: '2022-06-08',
        invoice_no: '1000000112',
        customer: 'Haro Taro',
        status: 'Posted'    
    },
    {
        key: '6',
        receipt_no: '10001215',
        invoice_date: '2022-06-08',
        invoice_no: '1000000113',
        customer: 'I got horns',
        status: 'Posted'    
    },
  ];


export default sampledata;